<template>
    <div v-if="loaded">
        <div class="mx-4 my-2" v-if="!can_use_unlimited_vips">
            <subscription-notice :message="message" />
        </div>
        <div
            class="mx-4 pb-12 border-b border-gray-dark"
            :class="!can_use_vip_domains ? 'opacity-50' : ''"
        >
            <div class="mt-6 w-11/12 md:w-1/2 mx-auto">
                <h3 class="font-bold">VIP Domains</h3>
                <p class="text-gray-darker text-sm">
                    Emails from any of these domains will be immediately
                    delivered.
                </p>
                <tag-input
                    class="bg-gray-light"
                    :disabled="!can_use_vip_domains"
                    placeholder="Add domains..."
                    :current="whitelists.domains"
                    @change="(newDomains) => (whitelists.domains = newDomains)"
                />
                <div class="mt-4 w-full">
                    <p class="text-destructive" v-if="errors.domains">
                        {{ errors.domains }}
                    </p>
                </div>
            </div>
        </div>
        <div
            class="mx-4 pb-12 border-b border-gray-dark"
            :class="!can_use_vip_addresses ? 'opacity-50' : ''"
        >
            <div class="mt-6 w-11/12 md:w-1/2 mx-auto">
                <h3 class="font-bold">VIP Email Addresses</h3>
                <p class="text-gray-darker text-sm">
                    Emails from any of these address will be immediately
                    delivered.
                </p>
                <tag-input
                    class="bg-gray-light"
                    :disabled="!can_use_vip_addresses"
                    placeholder="Add email addresses..."
                    :current="whitelists.addresses"
                    @change="
                        (newAddresses) => (whitelists.addresses = newAddresses)
                    "
                    :suggestions="queryContacts"
                />
                <div class="mt-4 w-full">
                    <p class="text-destructive" v-if="errors.addresses">
                        {{ errors.addresses }}
                    </p>
                </div>
            </div>
        </div>
        <div class="mx-4">
            <div
                class="mt-6 w-11/12 md:w-1/2 mx-auto"
                :class="!can_use_vip_keywords ? 'opacity-50' : ''"
            >
                <h3 class="font-bold">VIP Keywords</h3>
                <p class="text-gray-darker text-sm">
                    Emails containing any of these words will be immediately
                    delivered.
                </p>
                <tag-input
                    class="bg-gray-light"
                    :disabled="!can_use_vip_keywords"
                    placeholder="Add keywords..."
                    :current="whitelists.keywords"
                    @change="
                        (newKeywords) => (whitelists.keywords = newKeywords)
                    "
                />
                <div class="mt-4 w-full">
                    <p class="text-destructive" v-if="errors.keywords">
                        {{ errors.keywords }}
                    </p>
                </div>
                <p class="text-gray-darker text-sm">
                    VIP Keywords can be used to NOT miss out on emails like
                    password-resets and email-confirmations.
                    <a
                        href="https://support.mailmanhq.com/en/article/how-not-to-miss-transactional-emails-like-password-resets-and-email-confirmations-1pvz8uc/"
                        target="_blank"
                        class="font-bold text-primary"
                        >Learn how.</a
                    >
                </p>
            </div>
        </div>
        <div
            class="mx-4 mt-12 pb-12"
            :class="!can_use_vip_domains ? 'opacity-50' : ''"
        >
            <div class="w-11/12 md:w-1/2 mx-auto">
                <progressable-button
                    type="submit"
                    class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                    :loading="loading"
                    :state="loadingState"
                    :disabled="!can_use_vip_domains"
                    @click.native="save"
                >
                    Save changes
                </progressable-button>
            </div>
        </div>
    </div>
    <div v-else>
        <loading />
    </div>
</template>

<script>
export default {
    data() {
        return {
            current: {},
            can_use_vip_domains: false,
            can_use_vip_addresses: false,
            can_use_vip_keywords: false,
            can_use_unlimited_vips: false,
            loaded: false,
            loading: false,
            loadingState: "...",
            whitelists: {
                domains: [],
                addresses: [],
                keywords: [],
            },
            errors: {},
        };
    },
    computed: {
        message() {
            return this.can_use_vip_domains
                ? "You can add 2 domains, 4 email addresses and 6 keywords as VIP. Upgrade to unlock unlimited VIPs."
                : "Upgrade to premium and unlock all these features.";
        },
    },
    mounted() {
        axios
            .get(`/api/mailbox`)
            .then((response) => {
                this.current = response.data.data.whitelists;
                this.can_use_vip_domains =
                    User.permissions.use_feature_vip_domains;
                this.can_use_vip_addresses =
                    User.permissions.use_feature_vip_addresses;
                this.can_use_vip_keywords =
                    User.permissions.use_feature_vip_keywords;
                this.can_use_unlimited_vips =
                    User.permissions.use_unlimited_feature_vip_domains;
                this.reset();
                this.loaded = true;
            })
            .catch((err) => {
                console.error(err);
            });
    },
    methods: {
        save() {
            this.errors = {};
            this.loadingState = "Saving...";
            this.loading = true;

            axios
                .put(`/api/mailbox`, {
                    whitelists: this.whitelists,
                })
                .then(() => {
                    Event.$emit("toast", {
                        text: "Great! Changes saved successfully.",
                    });
                })
                .catch((err) => {
                    if (err.response.status === 422) {
                        this.handleErrors(err.response.data);
                    }
                    console.error(err);
                })
                .then(() => {
                    this.loading = false;
                });
        },
        handleErrors(response) {
            this.errors.domains =
                _.first(response.errors["whitelists.domains"]) || "";
            this.errors.addresses =
                _.first(response.errors["whitelists.addresses"]) || "";
            this.errors.keywords =
                _.first(response.errors["whitelists.keywords"]) || "";
            this.errors.general = response.message;

            if (
                Object.keys(response.errors).some(function (k) {
                    return ~k.indexOf("whitelists.addresses.");
                })
            ) {
                // it has invalid addresses
                this.errors.addresses =
                    "One or more of these are not valid email addresses.";
            }

            if (
                Object.keys(response.errors).some(function (k) {
                    return ~k.indexOf("whitelists.domains.");
                })
            ) {
                // it has invalid addresses
                this.errors.domains =
                    "One or more of these are not valid domains.";
            }
        },
        reset() {
            this.whitelists.domains = this.current.domains;
            this.whitelists.addresses = this.current.addresses;
            this.whitelists.keywords = this.current.keywords;
        },
        queryContacts(input, callback) {
            axios
                .get(`/api/contacts?query=${input}`)
                .then((response) => {
                    callback(
                        response.data.data.map((contact) => {
                            return contact.email;
                        })
                    );
                })
                .catch((err) => console.error);
        },
    },
};
</script>
